import React from "react";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)(({ theme }) => ({
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function DeleteAllAnnotationsModal({
  onClose,
  show,
  deleteAllAnnotations,
  materials,
  displayedPages,
  currentMaterialPage,
  optionalToDeleteAnnotationMeta
}) {
  const onSubmit = () => {
    console.log({ optionalToDeleteAnnotationMeta });
    if (Array.isArray(optionalToDeleteAnnotationMeta) && optionalToDeleteAnnotationMeta?.length > 0) {
      (optionalToDeleteAnnotationMeta ?? []).forEach(({ bookId, pages }) => {
        if (typeof bookId === "string" && Array.isArray(pages)) {
          deleteAllAnnotations({ bookId, pages });
        }
      });
    } else {
      console.log("else");
      // is embedded
      if (materials?.length === 1 && materials[0].category.view === "single") {
        deleteAllAnnotations({ bookId: materials[0]._id, pages: [currentMaterialPage] });
      }
      deleteAllAnnotations({ bookId: "", pages: displayedPages });
    }

    onClose();
  };
  if (!show) return null;
  return (
    <Dialog open={show}>
      <DialogTitle>Löschen bestätigen</DialogTitle>
      <DialogContent>
        <DialogContentText>Alle Anmerkungen wirklich löschen?</DialogContentText>
      </DialogContent>
      <DialogActions style={{ pointerEvents: "auto" }}>
        <StyledButton
          onClick={onSubmit}
          style={{
            pointerEvents: "auto"
          }}
          color="primary"
        >
          Löschen
        </StyledButton>
        <StyledButton variant="text" color="primary" onClick={onClose}>
          Abbrechen
        </StyledButton>
      </DialogActions>
    </Dialog>
  );
}

DeleteAllAnnotationsModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  deleteAllAnnotations: PropTypes.func.isRequired,
  displayedPages: PropTypes.number.isRequired
};

export default DeleteAllAnnotationsModal;
